import type { CSSProperties, ReactNode } from "react";

interface Props {
  children: ReactNode;
  style?: CSSProperties;
  padding?: number | string;
  onClick?: () => void;
  "data-testid"?: string;
  [dataAttr: `data-${string}`]: string | undefined;
}

export function Card({
  children,
  style,
  padding = 20,
  onClick,
  ...rest
}: Props) {
  return (
    <div
      onClick={onClick}
      {...rest}
      style={{
        background: "var(--surface)",
        borderRadius: "var(--r-lg)",
        padding,
        boxShadow: "var(--shadow-sm)",
        border: "1px solid var(--line)",
        cursor: onClick ? "pointer" : undefined,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
